import React, { useState } from "react";
import { Pencil, Plus, Trash2 } from "lucide-react";

const CourseFaqSection = () => {
  const [faqs, setFaqs] = useState([]);

  const handleAddQuestion = () => {
    setFaqs((currentFaqs) => [
      ...currentFaqs,
      {
        id: Date.now(),
        question: "",
      },
    ]);
  };

  const handleQuestionChange = (faqId, nextQuestion) => {
    setFaqs((currentFaqs) =>
      currentFaqs.map((faq) =>
        faq.id === faqId ? { ...faq, question: nextQuestion } : faq,
      ),
    );
  };

  const handleDeleteQuestion = (faqId) => {
    setFaqs((currentFaqs) => currentFaqs.filter((faq) => faq.id !== faqId));
  };

  return (
    <section className="mt-6 overflow-hidden rounded-xl border border-[#E5E7EB] bg-white shadow-[0_1px_2px_#0000000D]">
      <header className="border-b border-[#E5E7EB] bg-[#F9FAFB] px-4 py-4 sm:px-6">
        <h3 className="text-base text-[#1F2937] sm:text-lg">FAQ&apos;s</h3>
      </header>

      <div className="mx-auto max-w-[1370px] px-4 pb-8 pt-6 sm:px-6 sm:pt-8 md:pb-12">
        <div className="flex flex-col gap-5 lg:flex-row lg:justify-between lg:gap-10">
          {!faqs.length ? (
            <p className="w-full rounded-md border border-dashed border-[#D1D5DB] px-3 py-4 text-sm text-[#6B7280] sm:px-4 sm:py-6">
              No FAQ added yet. Click Add Question to create one.
            </p>
          ) : (
            <div className="w-full max-w-[1040px] space-y-6">
              {faqs.map((faq) => (
                <div key={faq.id}>
                  <p className="mb-1 text-sm text-[#374151]">Question</p>
                  <div className="flex items-center gap-3 rounded-lg border border-[#D1D5DB] px-3 py-2.5">
                    <input
                      type="text"
                      value={faq.question}
                      onChange={(event) =>
                        handleQuestionChange(faq.id, event.target.value)
                      }
                      placeholder="How do I enroll in this Course"
                      className="min-w-0 w-full bg-transparent text-sm outline-none placeholder:text-[#6B7280]"
                    />

                    <button
                      type="button"
                      aria-label="Delete question"
                      onClick={() => handleDeleteQuestion(faq.id)}
                      className="shrink-0 text-[#6B7280] transition hover:text-[#374151]"
                    >
                      <Trash2 size={18} />
                    </button>
                    <button
                      type="button"
                      aria-label="Edit question"
                      className="shrink-0 text-[#6B7280] transition hover:text-[#374151]"
                    >
                      <Pencil size={18} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="flex items-center justify-end lg:shrink-0">
            <button
              type="button"
              onClick={handleAddQuestion}
              className="inline-flex w-full items-center justify-center gap-2 bg-[#923D8C] px-6 py-2.5 text-white transition hover:opacity-95 sm:w-auto"
            >
              <Plus size={18} />
              <span className="text-sm">Add Question</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseFaqSection;